import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=7d04d2ac&lang=pug&"
import script from "./Category.vue?vue&type=script&lang=ts&"
export * from "./Category.vue?vue&type=script&lang=ts&"
import style0 from "./Category.vue?vue&type=style&index=0&id=7d04d2ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports